export interface Role {
  id: number;
  name: string;
}

export const isAdminRole = (name:string) => name.toLowerCase() === 'admin'

export interface IRoleRepository {
  getAll(): Promise<Role[]>;
}
